import React from 'react';
import PropTypes from 'prop-types';
// Styles
import './Header.css';

const NAME = 'header';

function Header({
    children,
    classOverride,
    As,
    color
}) {
    const colorStyle = color ? { 'color': color } : {};
    return (
        <As style={colorStyle} className={`${NAME} ${classOverride} ${NAME}-${As}`}>{children}</As>
    )
}

Header.defaultProps = {
    classOverride: '',
    As: 'h1',
    color: null
};

Header.propTypes = {
    // Text
    children: PropTypes.any.isRequired,
    // Custom class
    classOverride: PropTypes.string,
    // Header tag
    As: PropTypes.string,
    // Font color
    color: PropTypes.string
};
export default Header;
